<template>
  <div class="product">
    <ProductCard v-if="teaser" :rate="rate" title="Contents and equipment" />
    <ProductConfig v-else class="product-config" :rate="rate">
      <div class="container-wrap">
        <AppSelect
          v-model="form.portablePropertyLimit"
          help="Things like computers, laptops, TVs, camera equipment and travelling stock"
          placeholder="Select amount"
          @input="handleInput"
        >
          <div slot="label">
            What is the value of your computer and electronic equipment and portable equipment?
          </div>
          <option
            v-for="val in ['2500', '3000', '4000', '5000', '6000', '7000', '8000', '9000', '10000', '15000', '20000']"
            :key="`prop-limit-${val}`"
            :value="val"
          >
            {{ val | currency }}
          </option>
        </AppSelect>
      </div>

      <Transition name="slide-down">
        <div v-if="form.portablePropertyLimit">
          <div class="container-wrap bg-white">
            <AppSelect
              v-model="form.fixedPropertyLimit"
              help="Things like desks, chairs, wall coverings, fittings and filing cabinets"
              placeholder="Select amount"
              name="fixed-property-limit"
              @input="handleInput"
            >
              <option
                v-for="val in ['0', '2500', '5000', '7500', '10000', '15000', '25000', '50000', '75000', '100000']"
                :key="val"
                :value="val"
              >
                {{ val === 0 ? 'None' : val | currency }}
              </option>
              <div slot="label">
                What is the value of all contents and tenant's improvements (other than computer and electronic equipment and portable equipment) owned by the business?
              </div>
            </AppSelect>
          </div>

          <div class="container-wrap">
            <AppSwitch id="content-damage" v-model="form.isRevenueProtectionLimit" @input="handleInput">
              <div slot="label">
                Include cover for additional expenses needed to keep your business running following damage to your
                contents, equipment or premises?
              </div>
              <p slot="help">
                This covers things like additional rent for temporary premises and the cost of hiring replacement
                equipment over a period of up to 12 months.
              </p>
            </AppSwitch>

            <Transition name="slide-down">
              <div v-if="form.isRevenueProtectionLimit">
                <AppMultipleChoice
                  v-model="form.revenueProtectionLimit"
                  :data-options="['10000', '25000', '50000', '100000']"
                  filter="currency"
                  @input="handleInput"
                >
                  <span slot="header">Select your limit</span>
                </AppMultipleChoice>
              </div>
            </Transition>
          </div>

          <div class="container-wrap bg-white">
            <AppSwitch id="employers-liability" v-model="form.moneyAssaultActive" @input="handleInput">
              <div slot="label">Include £2,500 cover for theft of cash?</div>
            </AppSwitch>
          </div>
        </div>
      </Transition>
    </ProductConfig>
  </div>
</template>

<script>
import ProductCard from '@/components/products/Card.vue'
import ProductConfig from '@/components/products/Config.vue'
import AppMultipleChoice from '@/components/products/form/MultipleChoice.vue'
import AppSwitch from '@/components/products/form/Switch.vue'
import AppSelect from '@/components/products/form/Select.vue'
import rateMixin from '@/mixins/rate'

export default {
  // filters: {},
  components: {
    ProductCard,
    ProductConfig,
    AppMultipleChoice,
    AppSwitch,
    AppSelect,
  },
  mixins: [rateMixin],
  props: {
    teaser: {
      type: Boolean,
      default: false,
    },
    rate: {
      type: Object,
      required: true,
    },
  },
  data () {
    if (this.teaser) return {}

    const defaultRatingInputs = {
      id: 'OfficeCover',
      key: 'AvivaCommercialCombined\\OfficeCover',
      active: true,
      fixedPropertyLimit: null,
      portablePropertyLimit: null,
      portablePropertyJurisdiction: 'Worldwide',
      revenueProtectionLimit: 0,
      moneyAssaultActive: false,
      errors: [],
    }

    // overwrite defaults with what ratingEngine returns
    let ratingInputs = { ...defaultRatingInputs, ...this.rate.ratingInputs }

    // if there's a rate passed, overwrite default inputs
    const rate = this.getRate(this.rate.key)
    if (rate) ratingInputs = { ...ratingInputs, ...rate.ratingInputs }

    return {
      productKey: 'AvivaCommercialCombined',
      showExtended: false,
      loading: false,
      form: {
        ...ratingInputs,
        // can't access this.getters here - need to access directly via $store
        productUuid: this.getAvailableProduct('AvivaCommercialCombined').id,
        isRevenueProtectionLimit: parseFloat(ratingInputs.revenueProtectionLimit) !== 0,
      },
    }
  },
  mounted () {
    if (!this.teaser) {
      this.handleSubmit()
    }
  },
  // @todo - add mapGetters - PT
  methods: {
    validate () {
      if (
        !this.form.fixedPropertyLimit ||
        !this.form.portablePropertyLimit ||
        (this.form.isRevenueProtectionLimit && this.form.revenueProtectionLimit === 0)
      ) { return false }

      return true
    },
    handleSubmit () {
      // reset estimate if it has already been submitted for this rate
      this.$store.commit('updateEstimate', null)

      if (!this.validate()) {
        return
      }

      this.loading = true

      if (!this.form.isRevenueProtectionLimit) this.form.revenueProtectionLimit = 0

      this.updateRate(this.form)
        .then(() => (this.loading = false))
        .catch(() => (this.loading = false))
    },
    handleInput () {
      this.handleSubmit()
    },
  },
}
</script>
